import React from 'react'

const ContentSection = () => {
    return (
        <section className='px-4 py-10'>
            <div className='grid grid-cols-1 md:grid-cols-2 gap-5 max-w-7xl w-full mx-auto'>
                <h1 className="text-3xl md:text-4xl font-bold text-headings max-w-[400px] w-full">
                    Drive with Tuber
                    Earn on Your Terms
                </h1>

                <p className='text-light_black text-sm md:text-lg'>
                    Join Australia’s fastest-growing commercial delivery network and take control of your work
                    schedule. Whether you drive a ute, van, or truck, Tuber connects you with high-paying, on-demand
                    delivery jobs for the trade, construction, and commercial sectors.
                </p>
            </div>
        </section>
    )
}

export default ContentSection